<template>
  <div class="row">
<!--    <div class="col">-->
<!--      &lt;!&ndash;<v-facebook-login :app-id="$config.FACEBOOK_CLIENT_ID.toString()" @login="facebookLogin" @logout="facebookLogout"></v-facebook-login>&ndash;&gt;-->
<!--      <v-facebook-login-scope v-model="vModel" :app-id="$config.FACEBOOK_CLIENT_ID.toString()" @login="facebookLogin" v-if="!$auth.user().facebook_id">-->
<!--        <button slot-scope="scope" :disabled="scope.disabled" @click="scope.login" class="btn btn-block btn-facebook">-->
<!--          <i class="loader" v-if="scope.working"></i>-->
<!--          <span v-if="scope.enabled">-->
<!--            <font-awesome-icon :icon="['fab', 'facebook']" class="float-left mt-1"></font-awesome-icon>-->
<!--            Connect with Facebook-->
<!--          </span>-->
<!--          <span v-if="scope.working">-->
<!--            Please wait...-->
<!--          </span>-->
<!--        </button>-->
<!--      </v-facebook-login-scope>-->
<!--      <loading-button :loading="facebookLoading" block variant="facebook" @submit="facebookLogout" v-if="$auth.user().facebook_id">-->
<!--        <font-awesome-icon :icon="['fab', 'facebook']" class="float-left mt-1"></font-awesome-icon>-->
<!--        Disconnect from Facebook-->
<!--      </loading-button>-->
<!--    </div>-->
<!--    <div class="col">-->
<!--      <GoogleLogin :client_id="$config.GOOGLE_CLIENT_ID" :onSuccess="googleLogin" class="btn btn-google-plus btn-block" v-if="!$auth.user().google_id">-->
<!--        <font-awesome-icon :icon="['fab', 'google-plus']" class="float-left mt-1"></font-awesome-icon>-->
<!--        Connect with Google-->
<!--      </GoogleLogin>-->
<!--      <loading-button :loading="googleLoading" @submit="googleLogout" block variant="google-plus" v-if="$auth.user().google_id">-->
<!--        <font-awesome-icon :icon="['fab', 'google-plus']" class="float-left mt-1"></font-awesome-icon>-->
<!--        Disconnect from Google-->
<!--      </loading-button>-->
<!--    </div>-->
  </div>
</template>

<script>
// import { VFBLoginScope as VFacebookLoginScope } from 'vue-facebook-login-component';
// import { GoogleLogin } from 'vue-google-login';

export default {
  name: 'SocialConnectionButtons',
  // components: {VFacebookLoginScope, GoogleLogin},
  data () {
    return {
      googleLoading: false,
      facebookLoading: false
    };
  },
  methods: {
    facebookLogin (data) {
      this.axios.post('/social/facebook', {user_id: data.authResponse.userID}).then(() => {
        this.$auth.fetch();
      });
    },
    facebookLogout () {
      this.facebookLoading = true;
      this.axios.post('/social/logout/facebook').then(() => {
        this.$auth.fetch().then(() => {
          this.facebookLoading = false;
        });

      });
    },
    googleLogin (data) {
      this.axios.post('/social/google', {user_id: data.El}).then(() => {
        this.$auth.fetch();
      });
    },
    googleLogout () {
      this.googleLoading = true;
      this.axios.post('/social/logout/google').then(() => {
        this.$auth.fetch().then(() => {
          this.googleLoading = false;
        });
      });
    }
  },
  computed: {
    vModel: {
      get () {
        return this.value;
      },
      set (value) {
        this.$emit('input', value);
      }
    }
  }
};
</script>

<style scoped>

</style>
